











































import { Component, Vue, Watch, Ref, ProvideReactive } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { ALL_PAYCHECK_PERIODS } from '@/queries/PaycheckPeriod';
import { GQL_currentUnitPaycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import { GQL_PaycheckPeriodSave } from '@/queries/global';
import PaycheckPeriodsTableForm from '@/components/PaycheckPeriod/PaycheckPeriodsTableForm.vue';
import PaycheckPeriodsGenerateForm from '@/components/PaycheckPeriod/PaycheckPeriodsGenerateForm.vue';
import BeforeChangeWrapper from '@/components/BeforeChangeWrapper.vue';
import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';
import PermissionService from '@/utils/permission-service';

@Component({
  components: {
    PaycheckPeriodsTableForm,
    BeforeChangeWrapper,
    PaycheckPeriodsGenerateForm,
  },
})
export default class PaycheckPeriods extends Vue {
  @SmartQuery<PaycheckPeriods, GQL_currentUnitPaycheckPeriods>({
    query: ALL_PAYCHECK_PERIODS,
    update: data => data.currentUnit.paycheckPeriods as GQL_PaycheckPeriodSave[],
    result() { this.setFormPeriods() },
  }) private paycheckPeriods?: GQL_PaycheckPeriodSave[];

  @Ref() private formRef?: PaycheckPeriodsTableForm;

  // Year dropdown behavior

  private year: number = this.$dayjs().year();

  @ProvideReactive()
  private get editable(): boolean {
    return PermissionService.check('canCreatePaychecks');
  }

  private get yearsForDropdown(): number[] {
    const periodYears: number[] = (this.paycheckPeriods || [])
      .map(p => this.$dayjs(p.bookkeepingPeriod!, `YYYY-MM`, true).year())
      .sort();

    if (periodYears.length) {
      return [
        periodYears[0] - 1,
        ...uniq(periodYears),
        periodYears[periodYears.length - 1] + 1,
      ];
    } else {
      return [ this.$dayjs().year() ];
    }
  }

  // Form data behavior

  private paycheckFormPeriods: GQL_PaycheckPeriodSave[] = [];
  private validForm = true;

  @Watch('year')
  private setFormPeriods(): void {
    this.paycheckFormPeriods = cloneDeep(this.paycheckPeriods!.filter(p => this.$dayjs(p.bookkeepingPeriod!, `YYYY-MM`, true).year() === this.year));
    this.dirtyForm = false; // in case that we change to a year with no paycheck periods, and form doesn't show up
    this.formRef && this.formRef.resetFormDirty();
  }

  private onPeriodsGenerated(periods: GQL_PaycheckPeriodSave[]): void {
    this.paycheckFormPeriods = periods;
    this.$nextTick(() => this.formRef && this.formRef.setFormDirty());
  }

  // Unsaved changes

  @UnsavedChanges<PaycheckPeriods>({
    messages: {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      entity: i18n.t('PaycheckPeriod.paycheckPeriods'),
    },
    saveAndContinue() {
      if (!this.editable) return false;
      return !!this.formRef && this.formRef.savePaycheckPeriods();
    },
  }) private dirtyForm = false;

  private beforeYearChange(value: number, apply: Function, revert: Function): void {
    if (!this.dirtyForm) {
      apply();
      return;
    }

    this.$sPopup.alert(``, {
      title: this.$t('PaycheckPeriod.beforeChangingYear'),
      message: this.$t('PopupBody.unsavedChanges', { entity: this.$t('PaycheckPeriod.paycheckPeriods'), action: this.$t('PaycheckPeriod.changingYear') }),
      buttons: [
        {
          text: this.$t('PopupButton.yesSave'),
          color: 'primary',
          click: () => {
            this.formRef!.savePaycheckPeriods()
              .then(success => success ? apply() : revert());
          },
        },
        {
          text: this.$t('PopupButton.noDiscard'),
          click: () => apply(),
        },
      ],
      onCancel: () => revert(),
    });
  }
}
